import React from "react";
import { ViewOutputContainer } from "../../../containers";

const ViewOutput = (props) => {
  return <ViewOutputContainer {...props} />;
};

export default ViewOutput;
